window.addEventListener('scroll', function () {
    var enquireSection = document.querySelector('.mj-single-venue__enquire');
    var gallerySection = document.querySelector('.mj-single-venue__gallery');

    // Check if gallerySection is not null
    if (gallerySection) {
        var gallerySectionRect = gallerySection.getBoundingClientRect();

        if (gallerySectionRect.top < 0) {
            enquireSection.classList.add('sticky');
        } else {
            enquireSection.classList.remove('sticky');
        }
    }
});

function toggleEnquireInputs() {
    var checkbox = document.getElementById('mj-form__flexible-date');
    var input1 = document.getElementById('mj-form__start-hour');
    var input2 = document.getElementById('mj-form__end-hour');
    var select1 = document.getElementById('mj-form__start-date');
    var select2 = document.getElementById('mj-form__end-date');

    input1.disabled = checkbox.checked;
    input2.disabled = checkbox.checked;
    select1.disabled = checkbox.checked;
    select2.disabled = checkbox.checked;

    checkbox.value = checkbox.checked ? '1' : '0';

}

document.addEventListener('DOMContentLoaded', function () {
    var container = document.getElementById('mj-single-venue__inputs');
    var inputNumberGuest = document.querySelector('#mj-form__start-hour');

    if (inputNumberGuest) {
        inputNumberGuest.addEventListener('focus', function () {
            container.scrollTop += 100;
        });
    }
});